<template>
  <Instructions />
</template>

<script>
import global from '@itbpbg/lms-components/src/mixins/global';
import Instructions from '@itbpbg/lms-components/src/Exams/Instructions';

export default {
  components: {
    Instructions,
  },
  mixins: [global],
  layout: 'exam',
  async asyncData({
    store, route, redirect, $config,
  }) {
    await store.dispatch('exams/fetchPreview', route.params.id);

    if (store.state.auth.user) {
      return redirect(`${$config.lmsUrl}/exams/${store.state.exams.exam.id}/instructions`);
    }

    if (!store.state.exams.exam.id) {
      return redirect('/resources-center/');
    }

    return {};
  },
  head() {
    return {
      meta: this.metaProps({ robots: 'noindex, nofollow' }),
    };
  },
  mounted() {
    sessionStorage.removeItem('exam');
    if (process.client && window.screen.width < this.$store.state.breakPointLayoutResolution) {
      this.$router.push('/resources-center/');
    }
  },
};
</script>
